import { Directive, ElementRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AppContext } from '@farris/devkit';
import { AbstractEndEdit } from './abstract_end_edit';

@Directive({
  selector: '[input-end-edit]'
})
class InputEndEditDirective extends AbstractEndEdit implements OnInit {
  private nativeElement: any;
  constructor(protected appContext: AppContext, private elementRef: ElementRef) {
    super(appContext);
  }
  ngOnInit(): void {
    if (this.elementRef) {
      this.nativeElement = this.elementRef.nativeElement;
    }
  }
  /**
   * ç»æç¼è¾
   * @param message æ¶æ¯
   */
  public endEdit(message: any) {
    if (this.nativeElement) {
      const parent: any = this.nativeElement.parentNode || this.nativeElement.parentElement;
      const inputs: Array<any> = parent && Array.from(parent.getElementsByTagName('input')) || [];
      if (inputs && inputs.length > 0) {
        inputs.forEach(input => {
          if (input && typeof (input.blur) === 'function') {
            input.blur();
          }
        });
      }
    }
  }
}
export { InputEndEditDirective };
